import { type ChangeEvent, type KeyboardEvent } from "react";
import { formatPhone, normalizePhone } from "@/lib/employeeAuth";

type Props = {
  value: string;
  onChange: (next: string) => void;
  onSubmit?: () => void;
  disabled?: boolean;
  error?: string | null;
  autoFocus?: boolean;
};

export function PhoneInput({ value, onChange, onSubmit, disabled, error, autoFocus }: Props) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(formatPhone(e.target.value));
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && onSubmit) {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <div>
      <label
        htmlFor="phone"
        className="mb-2 block text-xs font-semibold uppercase tracking-widest text-gray-600"
      >
        Số điện thoại
      </label>
      <input
        id="phone"
        type="tel"
        inputMode="numeric"
        autoComplete="tel"
        autoFocus={autoFocus}
        disabled={disabled}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder="0901 234 567"
        aria-invalid={Boolean(error)}
        aria-describedby={error ? "phone-error" : undefined}
        className="h-12 w-full rounded-2xl border-2 border-pink-200 bg-pink-50/50 px-4 text-lg font-medium text-gray-900 outline-none transition duration-300 placeholder:text-gray-400 focus:border-pink-500 focus:ring-0 disabled:cursor-not-allowed disabled:opacity-60"
      />
      {error && (
        <div
          id="phone-error"
          role="alert"
          className="mt-3 rounded-xl border border-rose-100 bg-rose-50 p-3 text-center text-sm font-medium text-rose-500"
        >
          ❌ {error}
        </div>
      )}
      <p className="mt-2 text-right text-xs text-gray-400">
        {normalizePhone(value).length}/10 số
      </p>
    </div>
  );
}
